import React from "react";

import { ButtonStandard, Text } from "@performyard/py-components";

import { FormCard } from "./FormCard";

import type { ConfiguredForm, FormDataByType, FormType } from "./types";

import { MAX_FORMS_PER_TYPE } from "./constants";

type FormTabPanelProps<T extends FormType> = {
	formType: T;
	forms: ConfiguredForm<T>[];
	cycleStartDate: Date;
	allowEditing: boolean;
	wizardId: string;
	onChangeForm: (localId: string, data: FormDataByType[T]) => void;
	onRemoveForm: (localId: string) => void;
	onOpenSelectForms: () => void;
};

export const FormTabPanel = <T extends FormType>({
	formType,
	forms,
	cycleStartDate,
	allowEditing,
	wizardId,
	onChangeForm,
	onRemoveForm,
	onOpenSelectForms,
}: FormTabPanelProps<T>) => {
	const atFormCap = forms.length >= MAX_FORMS_PER_TYPE;

	return (
		<div className="flex flex-col gap-3 pt-3">
			{forms.map((form) => (
				<FormCard
					key={form.localId}
					formType={formType}
					form={form}
					cycleStartDate={cycleStartDate}
					readOnly={!allowEditing}
					onChange={onChangeForm}
					onDelete={allowEditing ? onRemoveForm : undefined}
					formIdAttr={`${wizardId}-form-${form.localId}`}
				/>
			))}

			{allowEditing && (
				<div>
					<Text size="paragraph-3" weight="semi-bold" color="neutral-9" dangerouslySetClassName="mb-1">
						Select Forms
					</Text>
					<div className="flex justify-center rounded-1 border border-dashed border-neutral-3 bg-neutral-0 p-4">
						<ButtonStandard
							color="green"
							variant="solid"
							onClick={onOpenSelectForms}
							disabled={atFormCap}
							dangerouslySetClassName="max-w-[94px]"
							data-testid={`add-forms-select-${formType}`}
						>
							Select Forms
						</ButtonStandard>
					</div>
				</div>
			)}
		</div>
	);
};
